"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _BucketLoggingStatus_1 = require("./_BucketLoggingStatus");
exports.PutBucketLoggingInput = {
    type: "structure",
    required: ["Bucket", "BucketLoggingStatus"],
    members: {
        Bucket: {
            shape: {
                type: "string"
            },
            location: "uri",
            locationName: "Bucket"
        },
        BucketLoggingStatus: {
            shape: _BucketLoggingStatus_1._BucketLoggingStatus,
            locationName: "BucketLoggingStatus",
            xmlNamespace: {
                uri: "http://s3.amazonaws.com/doc/2006-03-01/"
            }
        },
        ContentMD5: {
            shape: {
                type: "string"
            },
            location: "header",
            locationName: "Content-MD5"
        }
    },
    payload: "BucketLoggingStatus"
};
//# sourceMappingURL=PutBucketLoggingInput.js.map